import { render, staticRenderFns } from "./PortfolioReturnChart.vue?vue&type=template&id=6045e58f&"
import script from "./PortfolioReturnChart.vue?vue&type=script&lang=ts&"
export * from "./PortfolioReturnChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports